var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6902 8.08059H10.6488C10.5398 8.08059 10.4522 8.16815 10.4522 8.27719V11.2229C10.4522 11.2742 10.472 11.3254 10.51 11.3617C10.5464 11.3981 10.5959 11.4195 10.6488 11.4195L12.9304 11.4162C12.7569 12.8024 11.1874 13.9358 9.37998 13.9358C6.59283 13.9358 4.86965 11.3749 4.86965 9.00083C4.86965 6.66636 6.55648 4.25094 9.37998 4.25094C10.6042 4.25094 12.1803 4.98284 12.9948 5.68995C13.0345 5.72464 13.0857 5.73951 13.1369 5.73786C13.1898 5.73456 13.2394 5.70977 13.2724 5.67012L15.891 2.64837C15.9244 2.60958 15.9416 2.55937 15.9388 2.50825C15.936 2.45713 15.9136 2.40907 15.8762 2.37412C14.2009 0.821111 11.954 0 9.37998 0C4.01054 0 0.113159 3.78504 0.113159 8.99917C0.113159 14.215 4.01054 18 9.37998 18C17.4771 18 17.8868 9.89793 17.8868 8.27389C17.8868 8.16815 17.7993 8.08059 17.6902 8.08059Z",
    fill: "#6F9FE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.d51b2032.svg";
export { ForwardRef as ReactComponent };